import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgOrganization = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M10.957 15q.163-.262.244-.565a2.2 2.2 0 0 0 .089-.63V4.23h3.589q.516 0 .815.328.306.322.306.867v8.379q0 .544-.306.867-.3.328-.816.328zm1.876-7.447q0 .237.237.237H14.2q.238 0 .238-.237v-1.05q0-.23-.238-.23H13.07q-.237 0-.237.23zm0 2.588q0 .23.237.23H14.2q.238 0 .238-.23V9.09q0-.23-.238-.23H13.07q-.237 0-.237.23zm0 2.587q0 .23.237.23H14.2q.238 0 .238-.23v-1.05q0-.237-.238-.237H13.07q-.237 0-.237.236zM0 13.805V2.195q0-.552.3-.873Q.604 1 1.127 1H9.23q.524 0 .823.322.305.321.305.873v11.61q0 .544-.305.867-.3.328-.823.328H1.128q-.523 0-.829-.328Q0 14.35 0 13.805m2.828.138h4.764v-2.134a.47.47 0 0 0-.143-.361.5.5 0 0 0-.373-.138H3.344a.52.52 0 0 0-.374.137.47.47 0 0 0-.142.362zm-.225-9.417q0 .283.279.283h1.36q.291 0 .292-.283V3.252q0-.282-.293-.282h-1.36q-.278 0-.278.282zm3.283 0q0 .283.286.283h1.352q.292 0 .292-.283V3.252q0-.282-.292-.282H6.172q-.285 0-.286.282zm-3.283 2.68q0 .282.279.282h1.36q.291 0 .292-.283V5.932q0-.283-.293-.283h-1.36q-.278 0-.278.283zm3.283 0q0 .282.286.282h1.352q.292 0 .292-.283V5.932q0-.283-.292-.283H6.172q-.285 0-.286.283zM2.603 9.884q0 .282.279.282h1.36q.291 0 .292-.282V8.61q0-.283-.293-.283h-1.36q-.278 0-.278.283zm3.283 0q0 .282.286.282h1.352q.292 0 .292-.282V8.61q0-.283-.292-.283H6.172q-.285 0-.286.283z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgOrganization);
export default ForwardRef;
